import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Hero from './components/Hero/Hero';
import Features from './components/Features/Features';
import About from './components/About/About';
import Services from './components/Services/Services';
import Network from './components/Network/Network';
import Apply from './components/Apply/Apply';
import FAQ from './components/FAQ/FAQ';
import Contact from './components/Contact/Contact';
import Privacy from './components/Privacy/Privacy';
import Legal from './components/Legal/Legal';
import Terms from './components/Terms/Terms';
import CookieBanner from './components/CookieBanner/CookieBanner';
import AgeVerification from './components/AgeVerification/AgeVerification';
import SEO from './components/SEO/SEO';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import './styles/global.css';

// Schema.org Definitionen
const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Angel & Devil Network",
  "description": "Full-Service-Agentur für Webcam-Performer mit Equipment, Studio-Wohnungen & Plattform-Support",
  "url": "https://angel-devil.network",
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+49-XXX-XXXXXXX",
    "contactType": "customer service"
  }
};

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="min-h-screen bg-gradient-to-b from-deep-black via-deep-black to-black text-white flex flex-col">
          <Header />
          <ScrollToTop />
          <main className="flex-grow pt-20">
            <Routes>
              <Route path="/" element={
                <>
                  <SEO 
                    title="Dein Weg zum Webcam-Erfolg"
                    description="Werde Teil von Angel & Devil Network: Full-Service-Agentur für Webcam-Performer. Equipment, Studio-Wohnungen & Plattform-Support. Jetzt Karriere starten!"
                    schema={organizationSchema}
                  />
                  <Hero />
                  <Features />
                </>
              } />
              <Route path="/uber-uns" element={
                <>
                  <SEO 
                    title="Über Uns | Webcam-Agentur"
                    description="Erfahre mehr über Angel & Devil Network, deine Full-Service-Agentur für die Webcam-Branche. Wir begleiten dich auf deinem Weg zum Erfolg."
                  />
                  <About />
                </>
              } />
              <Route path="/leistungen" element={
                <>
                  <SEO 
                    title="Unsere Leistungen | Webcam Support"
                    description="Von Profi-Equipment über Studio-Wohnungen bis zu Plattform-Support: Entdecke unsere Leistungen und starte deine Karriere in der Webcam-Branche!"
                  />
                  <Services />
                </>
              } />
              <Route path="/wohnnetzwerk" element={
                <>
                  <SEO 
                    title="Studio-Apartments für Webcam-Performer"
                    description="Studio-Wohnungen in ganz Deutschland: Perfekt ausgestattet für Multi-Streaming und Content-Creation. Erfahre mehr über unser Wohnnetzwerk!"
                  />
                  <Network />
                </>
              } />
              <Route path="/bewerbung" element={
                <>
                  <SEO 
                    title="Bewirb dich jetzt | Webcam-Agentur"
                    description="Starte jetzt deine Karriere als Webcam-Performer. Bewirb dich bei Angel & Devil Network und profitiere von Rundum-Betreuung & Top-Ausstattung."
                  />
                  <Apply />
                </>
              } />
              <Route path="/faq" element={
                <>
                  <SEO 
                    title="FAQ - Häufige Fragen"
                    description="Antworten auf häufige Fragen zu Angel & Devil Network: Leistungen, Equipment, Wohnnetzwerk und mehr. Erfahre alles, was du wissen musst!"
                  />
                  <FAQ />
                </>
              } />
              <Route path="/kontakt" element={
                <>
                  <SEO 
                    title="Kontakt | Angel & Devil Network"
                    description="Kontaktiere uns für alle Fragen rund um deine Karriere als Webcam-Performer. Wir sind für dich da!"
                  />
                  <Contact />
                </>
              } />
              <Route path="/datenschutz" element={
                <>
                  <SEO 
                    title="Datenschutz"
                    description="Schutz deiner Daten ist uns wichtig. Erfahre mehr über die Verarbeitung deiner persönlichen Daten bei Angel & Devil Network."
                  />
                  <Privacy />
                </>
              } />
              <Route path="/impressum" element={
                <>
                  <SEO 
                    title="Impressum"
                    description="Rechtliche Informationen zu Angel & Devil Network. Erfahre mehr über unsere Kontaktdaten und rechtliche Hinweise."
                  />
                  <Legal />
                </>
              } />
              <Route path="/agb" element={
                <>
                  <SEO 
                    title="AGB"
                    description="Unsere Allgemeinen Geschäftsbedingungen. Erfahre mehr über die Zusammenarbeit mit Angel & Devil Network."
                  />
                  <Terms />
                </>
              } />
            </Routes>
          </main>
          <Footer />
          <CookieBanner />
          <AgeVerification />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
